import { CommonModule, NgClass } from "@angular/common";
import { MatMenuModule } from "@angular/material/menu";
import { Component, HostListener, Pipe, OnInit } from "@angular/core";
import { ToggleService } from "../sidebar/toggle.service";
import { MatButtonModule } from "@angular/material/button";
import { Router, RouterLink } from "@angular/router";
import { CustomizerSettingsService } from "src/app/core/services/customizer-settings.service";
import { AuthService } from "src/app/core/services/auth.service";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [CommonModule, NgClass, MatMenuModule, MatButtonModule, RouterLink],

  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
})
export class HeaderComponent implements OnInit {
  loggedInUser = localStorage.getItem("loggedInUser")
    ? JSON.parse(localStorage.getItem("loggedInUser")!)
    : null;
  // isSidebarToggled
  isSidebarToggled = false;

  // isToggled
  isToggled = false;

  constructor(
    private toggleService: ToggleService,
    public themeService: CustomizerSettingsService,
    public authService: AuthService,
    private router: Router,
  ) {
    this.toggleService.isSidebarToggled$.subscribe((isSidebarToggled) => {
      this.isSidebarToggled = isSidebarToggled;
    });
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }
  ngOnInit(): void {

  }
  // Burger Menu Toggle
  toggle() {
    this.toggleService.toggle();
  }

  // Navbar Sticky
  isSticky = false;
  @HostListener("window:scroll")
  checkScroll() {
    const scrollPosition =
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (scrollPosition >= 50) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
  }

  // Dark Mode
  toggleTheme() {
    this.themeService.toggleTheme();
  }

  logout() {
    this.authService.logout();
  }
}
